module.exports = __webpack_public_path__ + "static/media/srujun.61edaebe.jpg";